import { render, staticRenderFns } from "./dingApprovalDetail.vue?vue&type=template&id=256e3727&scoped=true"
import script from "./dingApprovalDetail.vue?vue&type=script&lang=js"
export * from "./dingApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./dingApprovalDetail.vue?vue&type=style&index=0&id=256e3727&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e3727",
  null
  
)

export default component.exports